import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { useAuthStore } from '../stores/authStore';

const selectAuthSlice = (s: ReturnType<typeof useAuthStore.getState>) => ({
  user: s.user,
  setUser: s.setUser,
  unreadInboxCount: s.unreadInboxCount,
  setUnreadInboxCount: s.setUnreadInboxCount,
});

/** ??? useUser() API????? authStore */
export function useAuth() {
  const slice = useAuthStore(useShallow(selectAuthSlice));
  return useMemo(() => slice, [slice]);
}
